import React from 'react';
import { LiveOrLineType, StoreType } from '../../store/spirs/types';
import { useMarketMenu } from '../../markets/marketMapping';
import { Fixture } from '../CommonSportDisplay/desktop/Sport/Fixture';
import { LevelProps } from './types';
import { useSelector } from 'react-redux';
import { makeSelectRouteTreeType } from '../VerticalMenu/selectors';

export const TreeFixture: React.FC<LevelProps & {mode: LiveOrLineType}> = props => {
    const { id, tree, mode } = props;

    const fixture = tree.fixtures[id];
    const fixtureWithMarkets = tree.f;

    const selectRouteTreeType = React.useMemo(makeSelectRouteTreeType, []);
    const route = useSelector((state: StoreType) => selectRouteTreeType(state));

    const needRender = fixture.cl || fixtureWithMarkets.indexOf(fixture.fi) > -1;
    if (!needRender) {
        return <></>
    }

    const { marketGroupItems, currentMarketGroup } = useMarketMenu(fixture.sid);
    const displayedMarketGroupItems = marketGroupItems.filter(el => el.display).map(el => el.marketGroup);

    const isAlreadyStarted = (id: number) => tree.alrds.indexOf(id) > -1;
    return (
        <Fixture
            marketGroupsToDisplay={displayedMarketGroupItems}
            isChessLive={fixture.cl}
            fixture={{
                ...fixture,
                ss: tree.ss[fixture.fi] || undefined,
                ms: tree.ms[fixture.fi] || undefined
            }}
            prefixPath={route}
            mode={mode}
            color={fixture.sc}
            mobileMarketGroup={currentMarketGroup}
            settings={tree.st}
            markets={tree.m[fixture.fi] || []}
            alreadyStarted={isAlreadyStarted(fixture.fi)}
        />
    )
};